import React from 'react';
import { Link, generatePath } from 'react-router-dom';
import { hubRoutes } from '../../../../general/urls';

import { SearchCHNode } from '../model';
import { getParent } from '../../../../general/node';

export const Component: React.FC<{
  rowData: SearchCHNode;
}> = ({ rowData }) => {
  const parent = getParent(rowData);
  return (
    <div className="ch-file-manager__cell-content_breadcrumbs">
      <Link title={parent.path} to={generatePath(hubRoutes.folder, { nodeId: parent.id })}>
        {parent.path}
      </Link>
    </div>
  );
};

export const SearchBreadcrumbsCell = (props: { rowData: SearchCHNode }) => <Component {...props} />;
